/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Exit Full Screen Icon component.
 */
export const ExitFullScreenIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M1 18.5H5.5V23H8.5V15.5H1V18.5ZM5.5 6.5H1V9.5H8.5V2H5.5V6.5ZM14.5 23H17.5V18.5H22V15.5H14.5V23ZM17.5 6.5V2H14.5V9.5H22V6.5H17.5Z' fill={iconColor} />
    </svg>
    
  );
};
